module.exports = __webpack_public_path__ + "assets/img/thumb-Coolabah-Turf-Service-Page.2fa4fc6f.jpg";